<template>
  <div class="edit-article-page">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">Poll Results
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          text
          style="text-transform: none;"
        >Back</v-btn>

      </div>
    </v-app-bar>
    <v-overlay
      v-if="loading"
      :absolute="true"
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-row
      class="px-4 py-4"
      v-else
    >
      <v-col
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <template v-if="!loading">
          <div v-if="sbPoll">
            <bar-chart :poll-data="chartData"></bar-chart>
          </div>
          <div
            v-else
            style="height: 100vh"
            class="d-flex justify-center align-center"
          >
            <h2>Unabled to retrieve sport betting poll. <router-link :to="{ name: 'sportsbetting-polls' }">Go back</router-link>
            </h2>
          </div>
          <div>
            <v-data-iterator
              :items="sbPoll.poll_options"
              hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                  class="mb-2"
                  color="indigo darken-5"
                  dark
                  flat
                >
                  <v-toolbar-title>Vote breakdown</v-toolbar-title>
                </v-toolbar>
              </template>

              <template>
                <v-row>
                  <v-col
                    v-for="option in sbPoll.poll_options"
                    :key="option.id"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-card v-if="option.poll_votes.length > 0">
                      <v-card-title class="subheading font-weight-bold">
                        {{ option.name }}
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-list dense>
                        <v-list-item
                          v-for="(vote, i) in votes[option.id]"
                          :key="i"
                        >
                          <v-list-item-content>{{ articleTitle(vote.article_id) }}</v-list-item-content>
                          <v-list-item-content class="align-end">
                            {{ vote.vote_count }}
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SBPoll from '@/models/SBPoll'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import BarChart from './BarChart'
import map from 'lodash/map'
import find from 'lodash/find'
import SportBettingArticle from '@/models/SportBettingArticle'

export default {
  name: 'SBPollsResult',

  data () {
    return {
      sbPoll: null,
      loading: true,
      chartData: {
        pollLabels: [],
        pollVoteCount: [],
        pollName: null
      },
      votes: {},
      articles: {}
    }
  },

  components: {
    AppBarNavIcon,
    BarChart
  },

  mounted () {
    this.getPoll()
  },

  methods: {
    async getArticle (id) {
      let tmp = await SportBettingArticle.find(id)
      this.$set(this.articles, id, tmp.data)
    },

    async getPoll () {
      this.loading = true
      await SBPoll.find(this.$route.params.id)
        .then(response => {
          this.sbPoll = new SBPoll(response.data)
        })
        .then(() => {
          if (this.sbPoll) {
            this.chartData.pollName = this.sbPoll.question
            map(this.sbPoll.poll_options, option => {
              this.chartData.pollLabels.push(option.name)
              this.chartData.pollVoteCount.push(option.total_votes)

              let tmpData = {}

              for (const vote of option.poll_votes) {
                if (!find(tmpData, { 'article_id': vote.sport_betting_article_id, 'option_id': option.id })) {
                  this.getArticle(vote.sport_betting_article_id)
                  tmpData[`${vote.sport_betting_article_id}`] = { 'article_id': vote.sport_betting_article_id, 'vote_count': 1, 'option_id': option.id }
                } else {
                  tmpData[`${vote.sport_betting_article_id}`].vote_count++
                }
              }
              console.log(this.loading)
              this.votes[option.id] = tmpData
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => { this.loading = false })
    },

    onCancel () {
      this.$router.replace({ name: 'sportsbetting-polls' })
    }

  },

  computed: {
    articleTitle () {
      return id => this.articles[id] ? this.articles[id].title : id
    }
  }

}
</script>
<style >
.edit-article-page {
  min-height: 100vh;
}
</style>
